import { inject, observer } from 'mobx-react';
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

@inject('alertStore')
@observer

class MensagemAlert extends React.Component {
  render () {
    return (
      <Dialog
        open={this.props.alertStore.exibir}
        onClose={this.props.alertStore.fecharAlert}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{this.props.alertStore.titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {this.props.alertStore.conteudo}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.alertStore.fecharAlert} color='primary' autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default MensagemAlert;
